import classNames from "classnames";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { OptimizationLabels } from "shared/labels";
import { useFormState } from "react-final-form";
import { OUTPUT_FINAL_ID, workspaceInsightsSelector, } from "store/rs-workspace/selectors/rs-workspace.selectors";
import { InsightInputType } from "store/rs-workspace/rs-workspace.types";
import WarnIcon from "icons/info_triangle.svg";
import InfoIcon from "icons/icn-info.svg";
import * as styles from "./styles.module.scss";
const ErrorMessage = () => {
    const { values } = useFormState();
    const workspaceInsights = useSelector(workspaceInsightsSelector);
    const { icon, message, isWarn } = useMemo(() => {
        let icon, message, isWarn = false;
        const currentInsight = workspaceInsights.find(({ id }) => id === values?.insightId);
        const selectedInputSetInputs = currentInsight?.state?.input?.inputSets?.find(({ id }) => id === values?.insightInputSetId)?.inputs;
        const output = currentInsight?.state.outputs.find(({ id }) => id === values?.outputId);
        const isFinal = values?.outputId === OUTPUT_FINAL_ID;
        const hasProcessDataOption = !!selectedInputSetInputs?.some((item) => item.inputType === InsightInputType.PROCESS_DATA);
        const hasSimulationOption = !!selectedInputSetInputs?.some((item) => item.inputType === InsightInputType.SIMULATION);
        const hasProcessData = !!selectedInputSetInputs?.some((item) => item.inputType === InsightInputType.PROCESS_DATA &&
            (isFinal ? hasProcessDataOption : item.id === output?.sourceA || item.id === output?.sourceB));
        const hasSimulation = !!selectedInputSetInputs?.some((item) => item.inputType === InsightInputType.SIMULATION &&
            (isFinal ? hasSimulationOption : item.id === output?.sourceA || item.id === output?.sourceB));
        if (hasProcessData && !hasSimulation) {
            isWarn = true;
            icon = React.createElement(WarnIcon, null);
            message = OptimizationLabels.INPUT_SOURCE_ERROR;
        }
        else if (hasSimulation && hasProcessData) {
            icon = React.createElement(InfoIcon, null);
            message = OptimizationLabels.INPUT_SOURCE_INFO;
        }
        return { icon, message, isWarn };
    }, [workspaceInsights, values?.insightId, values?.insightInputSetId, values?.outputId]);
    if (!icon || !message) {
        return null;
    }
    return (React.createElement("div", { className: styles.main },
        React.createElement("div", { className: classNames(styles.icon, { [styles.warn]: isWarn }) }, icon),
        React.createElement("div", { className: styles.message }, message)));
};
export default ErrorMessage;
